export default __webpack_public_path__ + "static/media/3064.783f4e2e.jpg";